module.exports = __webpack_public_path__ + "media/images/icons/vendors/webpic/weddingrings-17416b2a97e2b398ff6a72486dc90283.webp";